import type { BaseMessage, UserMessage } from '@sendbird/chat/message';

type SendbirdChannelLike = {
  url?: string;
  _url?: string;
  lastMessage?: BaseMessage | null;
};

/** Sendbird handler payloads may omit `url` on some SDK versions. */
export function getGroupChannelUrl(channel: SendbirdChannelLike | null | undefined): string | null {
  if (!channel) return null;
  if (channel.url) return channel.url;
  return channel._url ?? null;
}

export function getGroupChannelLastMessage(
  channel: SendbirdChannelLike | null | undefined,
): BaseMessage | null {
  if (!channel?.lastMessage) return null;
  return channel.lastMessage;
}

export function getMessageSenderUserId(message: BaseMessage | null | undefined): string | undefined {
  if (!message || message.messageType !== 'user') return undefined;
  return (message as UserMessage).sender?.userId;
}
